import { Dialog, DialogPanel, Button } from '@tremor/react';
import { Trans } from '@lingui/macro';

export function ConfirmModal({
  description,
  show,
  showModal,
  onConfirm,
  onCancel,
}: {
  readonly description?: string;
  readonly show: boolean;
  readonly showModal: React.Dispatch<React.SetStateAction<boolean>>;
  readonly onConfirm: () => void;
  readonly onCancel?: () => void;
}) {
  return (
    <Dialog
      open={show}
      onClose={() => {
        showModal(false);
        onCancel?.();
      }}
    >
      <DialogPanel className='overflow-visible'>
        <h3 className='text-lg font-semibold text-gray-900 dark:text-white'>
          <Trans>Are you sure?</Trans>
        </h3>
        {description ? <p className='mt-2'>{description}</p> : null}
        <div className='flex justify-end mt-4 gap-1'>
          {onCancel && (
            <Button variant='secondary' onClick={onCancel}>
              <Trans>Cancel</Trans>
            </Button>
          )}
          <Button onClick={onConfirm}>
            <Trans>Confirm</Trans>
          </Button>
        </div>
      </DialogPanel>
    </Dialog>
  );
}
